import { loadPerimeterX } from '@/common/utilities/nojq/_load.thirdparty.scripts.js';

function debounce(fn, wait) {
    let t;
    return function (...args) { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
}
function throttle(fn, wait) {
    let last = 0, t;
    return function (...args) {
        const now = Date.now();
        clearTimeout(t);
        if (now - last >= wait) { last = now; fn.apply(this, args); }
        else { t = setTimeout(() => { last = Date.now(); fn.apply(this, args); }, wait - (now - last)); }
    };
}

const isSSR = typeof window === 'undefined';

export default (app) => {
    if (!isSSR) {
        var widthBefore = 0;
        $.winStatus = {
            sensitive: 0,
            originalScrollTop: 0,
            isLandscape: false,
            scrollTop: 0,
            scrollLeft: 0,
            causeByKeyboard: false,
            isScrollDown: false,
            width: 0,
            height: 0,
        };
    }
    var _isLandscap = function () {
        var $body = $('#body');
        $.winStatus.width = $(window).outerWidth();
        $.winStatus.height = $(window).outerHeight();
        $.winStatus.isLandscape = $.winStatus.width > $.winStatus.height;
        if ($.winStatus.isLandscape) {
            $body.addClass('landscape');
            $body.removeClass('portrait');
        } else {
            $body.addClass('portrait');
            $body.removeClass('landscape');
        }
    };
    var _isScrollDown = function () {
        $.winStatus.originalScrollTop = $.winStatus.scrollTop;
        $.winStatus.scrollTop = $(window).scrollTop();
        var sensitive = 0;
        if ($.winStatus.scrollTop > $.winStatus.originalScrollTop) {
            $.winStatus.isScrollDown = true;
        } else if ($.winStatus.scrollTop < $.winStatus.originalScrollTop) {
            $.winStatus.isScrollDown = false;
        }
        sensitive = Math.abs($.winStatus.scrollTop - $.winStatus.originalScrollTop);
        $.winStatus.sensitive = sensitive;
    };
    var _updateByResize = function () {
        _isScrollDown();
        _isLandscap();
    };
    var _updatebyScroll = function () {
        _isScrollDown();
    };
    var _updateVH = function () {
        document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
    };
    //unbind is not working when use navigation to change page
    var unbind = function () {
        $(window).off('scroll.mvt');
        $(window).off('resize.mvt');
        $(document).off('keyup.mvt');
    };

    // --viewport-height is set to 100dvh in _reset.scss; JS only recalculates
    // on resize for older-browser fallback via _updateVH.
    // --scroll-size is only consumed by dialog/popownup/searchfilter overlays
    // that are never active on initial load; computed lazily on first use.

    var _winStatusInitialized = false;
    var _ensureWinStatus = function () {
        if (_winStatusInitialized) return;
        _winStatusInitialized = true;
        var scrollWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scroll-size', (scrollWidth > 0 ? scrollWidth : 0) + 'px');
        $.winStatus.scrollTop = $(window).scrollTop();
        $.winStatus.originalScrollTop = $.winStatus.scrollTop;
        $.winStatus.width = $(window).outerWidth();
        $.winStatus.height = $(window).outerHeight();
        $.winStatus.isLandscape = $.winStatus.width > $.winStatus.height;
    };

    var _updateWindowStatus = function (type) {
        _ensureWinStatus();
        $.winStatus.causeByKeyboard = $('input, select, textarea').is(':focus');
        switch (type) {
            case 'resize':
                _updateByResize();
                break;
            case 'scroll':
                _updatebyScroll();
                break;
            default:
                break;
        }
    };

    app.directive(
        'inital',
        isSSR
            ? {}
            : {
                  beforeMount: function () {
                      unbind();
                      import(/* webpackChunkName: "notification" */ '../utilities/nojq/_notification.js').then(m => m.initial());
                      // Defer PerimeterX well past LCP.  Load on first user
                      // interaction, or after 8 s — whichever comes first.
                      let _pxLoaded = false;
                      const _loadPX = () => {
                          if (_pxLoaded) return;
                          _pxLoaded = true;
                          window.removeEventListener('scroll', _loadPX, { passive: true });
                          window.removeEventListener('click', _loadPX);
                          window.removeEventListener('touchstart', _loadPX, { passive: true });
                          window.removeEventListener('keydown', _loadPX);
                          loadPerimeterX();
                      };
                      window.addEventListener('scroll', _loadPX, { passive: true });
                      window.addEventListener('click', _loadPX);
                      window.addEventListener('touchstart', _loadPX, { passive: true });
                      window.addEventListener('keydown', _loadPX);
                      setTimeout(_loadPX, 8000);
                      $(window).on('popstate', function () {
                          if (window.stopPop) {
                              window.stopPop = false;
                              return;
                          }
                          $(document).trigger('dom.popstate', history.state && history.state.key);
                      });
                      //only excute for winodw resize without thorrtle
                      window.addEventListener('resize', _updateVH);

                      $(document).on('keyup.mvt', function (e) {
                          if (!$('input, select, textarea').is(':focus')) {
                              if (e.key == 'Escape') {
                                  $(document).trigger('dom.key.esc');
                              } else if (e.key == 'ArrowLeft') {
                                  $(document).trigger('dom.key.left');
                              } else if (e.key == 'ArrowRight') {
                                  $(document).trigger('dom.key.right');
                              } else if (e.key == 'ArrowUp') {
                                  $(document).trigger('dom.key.up');
                              } else if (e.key == 'ArrowDown') {
                                  $(document).trigger('dom.key.down');
                              }
                          }
                      });
                      $(window).on(
                          'scroll.mvt',
                          throttle(function () {
                              _updateWindowStatus('scroll');
                              if (!$.winStatus.causeByKeyboard) {
                                  $(document).trigger('dom.scroll');
                              }
                          }, 500)
                      );
                      $(window).on(
                          'resize.mvt',
                          debounce(function () {
                              _updateWindowStatus('resize');
                              var isWidthChange = widthBefore != $(window).width();
                              $(document).trigger('dom.resize', isWidthChange);
                              widthBefore = $(window).width();
                          }, 500)
                      );
                      $(document).trigger('dom.load');
                      $('.spinnerholder').hide();
                      document.querySelector('#app').hidden = false;
                  },
              }
    );
};
